import { FormGroup, ValidatorFn } from "@angular/forms";

export function customValidator(): ValidatorFn {
  return (formGroup: FormGroup): { [key: string]: any } | null => {
    const registry = formGroup.get('registry');
    const autority = formGroup.get('officeCode');
    const role = formGroup.get('role');
    const otherFields = ['party', 'judge', 'registrationStartDate', 'registrationEndDate','hearingStartDate','hearingEndDate'];

    // Verifica se almeno uno degli altri campi è valorizzato
    const otherFieldsFilled = otherFields.some(fieldName => formGroup.get(fieldName)?.value);
    if (!otherFieldsFilled || ((!registry?.value || registry?.value === 'null') || (!role?.value || role?.value === 'null') || (!autority?.value || autority?.value === 'null'))) {
      return { 'invalid': true };
    } else {
      return null;
    }
  };
}
